'use client'

import { useState } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type IconType } from '@/defs/icon'
import { cn } from '@/utils/commonUtil'

import styles from './IconAdvancedRoot.module.scss'

type Props = {
  count?: number
  countBounce?: boolean
  name?: IconType
  variant?: 'clipboard' | 'filters' | 'cardFilters' | 'guide' | 'settings'
}

const CONFIG_ADVANCED: Record<string, IconType> = {
  cardFilters: 'filter',
  clipboard: 'paperclip',
  filters: 'sliders',
  guide: 'bars',
  settings: 'arrowDownArrowUp',
}

export const IconAdvancedRoot = ({ count, countBounce, variant }: Props) => {
  const [bounce, setBounce] = useState(false)
  const [prevCount, setPrevCount] = useState(count)

  const displayCount = count ? (count > 99 ? '99+' : count) : false
  const countSm = (count || 0) > 99

  const icon = CONFIG_ADVANCED[variant || ''] || 'diamond'

  if (count !== prevCount) {
    setPrevCount(count)
    if (countBounce) setBounce(true)
  }

  return (
    <span
      className={cn(styles.container, { bounce, countBounce, countSm, styles, variant })}
      onAnimationEnd={() => setBounce(false)}
    >
      <Icon name={icon} />
      {displayCount && (
        <span className={styles.count}>
          <span>{displayCount}</span>
        </span>
      )}
    </span>
  )
}
